import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import { type RootState } from "store/store"
import { type BillingState, type StripeEntitlementResponse } from "./types"

const initialState: BillingState = {
  entitlement: null,
  paywallDismissible: false,
  paywallOpen: false,
  portalUrl: "",
}

export const billingSlice = createSlice({
  name: "billing",
  initialState,
  reducers: {
    setBillingEntitlement: (state, action: PayloadAction<StripeEntitlementResponse | null>) => {
      state.entitlement = action.payload

      if (!action.payload?.requiresPortal) state.portalUrl = ""
      // A dismissible paywall is a user-opened plan catalog (trial merchants
      // browsing plans) — an entitled refresh must not yank it shut.
      if (action.payload?.entitled && !state.paywallDismissible) state.paywallOpen = false
    },
    setBillingPortalUrl: (state, action: PayloadAction<string>) => {
      state.portalUrl = action.payload.trim()
    },
    openBillingPaywall: (state, action: PayloadAction<{ dismissible?: boolean } | undefined>) => {
      state.paywallOpen = true
      state.paywallDismissible = Boolean(action.payload?.dismissible)
    },
    closeBillingPaywall: (state) => {
      state.paywallOpen = false
      state.paywallDismissible = false
    },
    clearBillingState: () => initialState,
  },
})

export const {
  clearBillingState,
  closeBillingPaywall,
  openBillingPaywall,
  setBillingEntitlement,
  setBillingPortalUrl,
} = billingSlice.actions

export const selectBillingState = (state: RootState) => state.billing
export const selectBillingEntitlement = (state: RootState) => state.billing.entitlement
export const selectBillingPaywallDismissible = (state: RootState) =>
  state.billing.paywallDismissible
export const selectBillingPaywallOpen = (state: RootState) => state.billing.paywallOpen
export const selectBillingPortalUrl = (state: RootState) => state.billing.portalUrl

export default billingSlice.reducer
